module.exports = __webpack_public_path__ + "img/dex2.18a3d2d9.png";